import {RouteConfig} from "vue-router";
import CookieDisabled from "@/views/Errors/CookieDisabled.vue";
import Unauthorized from "@/components/Unauthorized.vue";


const prefix = '/error'
const errorRoutes: Array<RouteConfig> = [
    {
        path: '/cookie/disabled',
        name: 'error-cookie-disabled',
        component: CookieDisabled,
    },
    {
        path: '/access-denied',
        name: 'access-denied',
        component: Unauthorized,
    },
]
errorRoutes.forEach((route) => {
    route.path = prefix + route.path
})
export default errorRoutes;
